import { Carousel } from 'antd'
import './Banner.less'
import { useContext } from 'react'
import { UserInfoContext } from 'context'

interface Props {
  lang: Lang,
}

interface BannerCarouselItem {
  description: string
  imgUrl: string
  alt: string
}

const carouselList: BannerCarouselItem[] = [
  {
    description: __('If you’re a Shopify/WooCommerce dropshipper, connect to BuckyDrop in one-click, dropship thousands of Chinese products from Taobao and run a care-free and affordable store.'),
    imgUrl: require('../../img/banner/banner_01.png'),
    alt: 'BuckyDrop drop-shipping',
  },
  {
    description: __('If you’re an eCommerce newbie, start your own online store quickly and easily at ultra low cost with everything ready for sale.'),
    imgUrl: require('../../img/banner/banner_02.png'),
    alt: 'BuckyDrop drop-shipping',
  },
  {
    description: __('If you’re an influencer, BuckyDrop will help you kick start your e-business to convert your traffic into profit cost-free.'),
    imgUrl: require('../../img/banner/banner_03.png'),
    alt: 'BuckyDrop drop-shipping',
  },
]

export default function Banner (props: Props): JSX.Element {
  const { lang } = props
  const { userInfo } = useContext(UserInfoContext)

  return (
    <div className={`homeBanner ${lang}`}>
      <div className='homeBannerBox'>
        <div className='homeBannerBox_left'>
          <h1 className='homeBannerBox_left_title1'>{__('Dropshipping Company for Easiest eCommerce Business Ever')}</h1>
          <h2 className='homeBannerBox_left_title2'>{__('BuckyDrop, a one-stop dropshipping solution provider for your e-business')}</h2>
          <p className='homeBannerBox_left_desc'>{__('It makes building your own online store easier and faster, and with the dropshipping plugin, it can help you source thousands of Chinese quality products, auto-fulfill orders, provide customized packing and ship directly to your consumers at low cost.')}</p>
          <a className='homeBannerBox_left_link' href={userInfo ? '/en/admin/home' : `/${lang}/register`}>
            {__('Start your dropshipping business now')}
          </a>
        </div>
        <div className='homeBannerBox_right'>
          <Carousel
            autoplay={!window.PRERENDER}
            effect='fade'
          >
            {
              carouselList.map((item, key) => (
                <div className={`bannerCarousel_item bannerCarousel_item${1 + key}`} key={key}>
                  <div className='carouselBox'>
                    <p className='carouselBox_desc'>{item.description}</p>
                    <img className='carouselBox_img' src={item.imgUrl} alt={item.alt} />
                  </div>
                </div>
              ))
            }
          </Carousel>
        </div>
      </div>
    </div>
  )
}

